function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".pil_svg__st0{fill:none;stroke:currentColor;stroke-width:3}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "pil_svg__st0",
  d: "M4.9 4.9h54.3v54.3H4.9z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "pil_svg__st0",
  d: "M37.4 37.4l5.4-5.4-5.4-5.4M19.6 32h23.2"
});

function SvgPil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "9 4 46 56"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iOSA0IDQ2IDU2Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLnN0MCB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgICBzdHJva2U6IGN1cnJlbnRDb2xvcjsKICAgICAgICBzdHJva2Utd2lkdGg6IDM7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxyZWN0IGNsYXNzPSJzdDAiIHg9IjQuOSIgeT0iNC45IiB3aWR0aD0iNTQuMyIgaGVpZ2h0PSI1NC4zIi8+CiAgPGc+CiAgICA8cG9seWxpbmUgY2xhc3M9InN0MCIgcG9pbnRzPSIzNy40IDM3LjQgNDIuOCAzMiAzNy40IDI2LjYiLz4KICAgIDxsaW5lIGNsYXNzPSJzdDAiIHgxPSIxOS42IiB5MT0iMzIiIHgyPSI0Mi44IiB5Mj0iMzIiLz4KICA8L2c+Cjwvc3ZnPg==";
export { SvgPil as ReactComponent };